// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';

export class AutocompleteTermOffset {
  readonly value?: string;
  readonly offset: number;

  constructor(data: { [key: string]: any } = {}) {
    this.value = data.value;
    this.offset = data.offset === undefined ? 0 : data.offset;
  }

  static zero(): AutocompleteTermOffset {
    const zeroValues: ExcludeMethodsDeep<AutocompleteTermOffset> = {
      offset: 0,
    };
    return new AutocompleteTermOffset(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type AutocompleteTermOffsetWireFormat = {
  value?: string;
  offset: number;
};

type NewAutocompleteTermOffsetProps = PartialDeep<
  AutocompleteTermOffset,
  { recurseIntoArrays: true }
>;
export const NewAutocompleteTermOffset: (
  props: NewAutocompleteTermOffsetProps,
) => AutocompleteTermOffset = (props) => new AutocompleteTermOffset(props);

type NewAutocompleteTermOffsetFromWireFormatProps = PartialDeep<
  AutocompleteTermOffsetWireFormat,
  { recurseIntoArrays: true }
>;
export const NewAutocompleteTermOffsetFromWireFormat: (
  props: NewAutocompleteTermOffsetFromWireFormatProps,
) => AutocompleteTermOffset = (props) => new AutocompleteTermOffset(props);
